import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: var(--space-3xl);
  text-align: center;
`;

const Gallery = () => {
  return (
    <Container>
      <h1>Photo Gallery</h1>
      <p>Beautiful photos from our RV adventures will be showcased here!</p>
    </Container>
  );
};

export default Gallery;
